// Flush di fine vita su Node: `beforeExit` (uscita naturale dell'event loop)
// e `SIGTERM` (stop orchestrato, es. deploy/container). Su SIGTERM, se i
// nostri sono gli unici listener, il listener si auto-rimuove e ri-manda il
// segnale al processo — preserva la terminazione di default senza loop. Con
// handler utente presenti, la terminazione resta a carico loro.

import type { Client } from '../../client'

/// Sottoinsieme di `process` usato dal lifecycle (iniettabile nei test).
export interface LifecycleProcessLike {
  pid: number
  on(event: string, listener: (...args: never[]) => unknown): unknown
  removeListener(event: string, listener: (...args: never[]) => unknown): unknown
  listeners(event: string): unknown[]
  kill(pid: number, signal: string): unknown
}

/// Installa i flush di lifecycle. Ritorna la funzione di disinstallazione.
export function installNodeLifecycle(
  client: Client,
  proc: LifecycleProcessLike = process as unknown as LifecycleProcessLike,
): () => void {
  const onBeforeExit = (): void => {
    void client.flush()
  }

  const onSigterm = async (): Promise<void> => {
    await client.flush()
    const others = proc.listeners('SIGTERM').filter((l) => l !== onSigterm)
    if (others.length === 0) {
      proc.removeListener('SIGTERM', onSigterm as never)
      proc.kill(proc.pid, 'SIGTERM')
    }
  }

  proc.on('beforeExit', onBeforeExit as never)
  proc.on('SIGTERM', onSigterm as never)

  return () => {
    proc.removeListener('beforeExit', onBeforeExit as never)
    proc.removeListener('SIGTERM', onSigterm as never)
  }
}
